<template>
<div style="margin-top:100px;text-align: center;">
  <h1 style="color: gray;margin-bottom: 20px;">Database is in under maintenance</h1>
  <div style="padding-bottom: 50px;">
    <v-btn to="/contactus" large depressed color="#FF9000">
    <v-icon>call</v-icon>&nbsp;Please Contact Us
  </v-btn>
  </div>
  <!-- <div class="kolkata5">
         <v-layout row wrap class="container">
            <v-flex xs12 sm12 md6 lg12>
                 <h1 style="padding-top:15px;color:whitesmoke;">Universities in {{countryName}}</h1>
            </v-flex>
         </v-layout>
     </div> -->
    <!-- <v-tabs
      v-model="tab"
      centered
      color="red"
      icons-and-text
    >
      <v-tabs-slider color="#EA0202" class="text_dec hvr"></v-tabs-slider>

      <v-tab style="cursor:pointer;color:white;" >
        Universities in <br/> {{countryName}}
        <v-icon color="white" :size="30">account_balance</v-icon>
      </v-tab>

      <v-tab style="cursor:pointer;color:white;" >
        Study in <br/> {{countryName}}
        <v-icon color="white" :size="30">tour</v-icon>
      </v-tab>

      <v-tab style="cursor:pointer;color:white;"  >
        Cost of Studying in <br/> {{countryName}}
        <v-icon color="white" :size="30">account_balance_wallet</v-icon>
      </v-tab>
      <v-tab style="cursor:pointer;color:white;" >
        Master in <br/> {{countryName}}
        <v-icon color="white" :size="30">school</v-icon>
      </v-tab>
      <v-tab style="cursor:pointer;color:white;" >
        Scholarship in <br/> {{countryName}}
        <v-icon color="white" :size="30">favorite</v-icon>
      </v-tab>
      <v-tab style="cursor:pointer;color:white;" >
        Student Visa in <br/> {{countryName}}
        <v-icon color="white" :size="30">public</v-icon>
      </v-tab>
      <v-tab style="cursor:pointer;color:white;" >
        Intake in <br/> {{countryName}}
        <v-icon color="white" :size="30">event</v-icon>
      </v-tab>
      <v-tab style="cursor:pointer;color:white;" >
        FAQ in <br/> {{countryName}}
        <v-icon color="white" :size="30">help</v-icon>
      </v-tab>
    </v-tabs>

    <v-tabs-items v-model="tab">
        <v-tab-item style="background-color:white">
            <v-container>
                <div class="card" v-for="item in universityList" :key="item.id">
                          <div class="container">
                            <div class="row" style="margin: 0px;">
                              <div class="col-lg-3 col-md-3 col-sm-12" style="border-right: 1px solid;border-color: rgb(190, 188, 188);">
                                 <img v-if="item.mySrc!=null" class="center" :src=item.src style="height: 150px;width: 150px;" />
                                 <img v-if="item.mySrc==null" class="center" src="../../assets/universitydemo.png" style="height: 150px;width: 150px;" />
                              </div>
                              <div class="col-lg-9 col-md-9 col-sm-12">
                                <h3 style="padding-top: 25px;padding-bottom: 15px;">{{item.universityName}}</h3>
                                <h5><v-icon style="color: darkcyan;">location_on</v-icon><span style="color:grey">Location: </span>{{item.location}}</h5>
                                <h5><v-icon style="color: darkcyan;margin-top: 10px;">bloodtype</v-icon><span style="color:grey">Type: </span>{{item.type}}</h5>
                                
                                <div class="row" style="padding-top: 15px;padding-bottom: 15px;margin: 0px;">
                                  <div class="col-lg-3 col-md-3 col-sm-12">
                                    <v-btn depressed color="warn">VIEW ALL COURSES</v-btn>
                                  </div>
                                  <div class="col-lg-3 col-md-3 col-sm-12">
                                    <v-btn depressed color="primary">APPLY NOW</v-btn>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
            </v-container>
        </v-tab-item>
        
        <v-tab-item style="background-color:white">
            <v-container>
                <div class="row" style="margin:0px;">
                    <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 mb-3">
                      <div class="container" style="padding-top: 50px;">
                        <p v-html="studyin"></p>
                      </div>
                    </div>
                  </div>
            </v-container>
        </v-tab-item>
        
        <v-tab-item style="background-color:white">
            <v-container>
                <div class="row" style="margin:0px;">
                    <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 mb-3">
                      <div class="container" style="padding-top: 50px;">
                        <p v-html="cost"></p>
                      </div>
                    </div>
                  </div>
            </v-container>
        </v-tab-item>
        <v-tab-item style="background-color:white">
            <v-container>
                <div class="row" style="margin:0px;">
                    <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 mb-3">
                      <div class="container" style="padding-top: 50px;">
                        <p v-html="master"></p>
                      </div>
                    </div>
                  </div>
            </v-container>
        </v-tab-item>
        <v-tab-item style="background-color:white">
            <v-container>
                <div class="row" style="margin:0px;">
                    <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 mb-3">
                      <div class="container" style="padding-top: 50px;">
                        <p v-html="scholarship"></p>
                      </div>
                    </div>
                  </div>
            </v-container>
        </v-tab-item>
        <v-tab-item style="background-color:white">
            <v-container>
                <div class="row" style="margin:0px;">
                    <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 mb-3">
                      <div class="container" style="padding-top: 50px;">
                        <p v-html="visa"></p>
                      </div>
                    </div>
                  </div>
            </v-container>
        </v-tab-item>
        <v-tab-item style="background-color:white">
            <v-container>
                <div class="row" style="margin:0px;">
                    <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 mb-3">
                      <div class="container" style="padding-top: 50px;">
                        <p v-html="intake"></p>
                      </div>
                    </div>
                  </div>
            </v-container>
        </v-tab-item>
        <v-tab-item style="background-color:white">
            <v-container>
                <div class="row" style="margin:0px;">
                    <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 mb-3">
                      <div class="container" style="padding-top: 50px;">
                        <p v-html="faq"></p>
                      </div>
                    </div>
                  </div>
            </v-container>
        </v-tab-item>
    </v-tabs-items> -->
</div>
</template>

<script>
import config from "./../../config.json";
export default {
  data() {
    return {
      valid: true,
      tab: null,
      isLoading: false,
      news: {},
      universityList: [],
      countryName: '',
      courseName: '',
      typeName: '',

      courseId: '',
      countryId: '',
      typeId: '',
      src: '',
      studyin: '',
      cost: '',
      master: '',
      scholarship: '',
      visa: '',
      intake: '',
      faq: '',
    };
  },

  mounted() {
      this.countryId = sessionStorage.getItem('countryId');
    this.courseId = sessionStorage.getItem('courseId');
    this.typeId = sessionStorage.getItem('typeId');
    this.countryName = sessionStorage.getItem('countryName');
    this.courseName = sessionStorage.getItem('courseName');
    this.typeName = sessionStorage.getItem('typeName');

      this.axios
      .get(config.API + "country/author/" + this.countryId, {
      })
      .then(response => {
        let res = response.data.author;

        this.studyin = res.studyin;
      this.cost = res.cost;
      this.master = res.master;
      this.scholarship = res.scholarship;
      this.visa = res.visa;
      this.intake = res.intake;
      this.faq = res.faq;
      })
      .catch(() => {
      });

      this.axios
          .post(
            config.API + `university/search`,
            {
              countryId: JSON.parse(this.countryId)
            },
            {
              headers: {
                Authorization: "bearer " + sessionStorage.getItem("token")
              }
            }
          )
          .then(response => {
            console.log(response);
              let list = response.data.result;

      for (let index = 0; index < list.length; index++) {
        const element = list[index];
        
        this.universityList.push({
          id: element.id,
          universityName: element.universityName,
          location: element.location,
          type: element.type,
          mysrc: element.src,
          src: config.API1 + 'university/files/' + element.src
        })
      }

      console.log(this.universityList);
          })
          .catch(() => {
            this.$toaster.error("Something went wrong!!");
            this.btnSave = false;
          });
  }
};
</script>

<style lang="css" scoped>
img.center {
    display: block;
    margin: 0 auto;
}
.kolkata5 {
    background-image: linear-gradient(to bottom,rgba(245, 159, 30, 0.73), rgba(250, 206, 9, 0.73)), url('http://www.royalacpaints.com/images/about-us-banner.jpg');
    background-size: cover;
}
</style>
